import React from 'react';
import { Stream } from '@cloudflare/stream-react';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import IEFallbackWrapper from 'components/IEFallbackWrapper';
import CustomLightboxContainer from './CustomLightboxContainer';

const StyledVideo = styled.video`
  width: 70vw;
  max-height: 80vh;
  user-select: all;
  pointer-events: all;
  background-color: black;

  @media (max-width: 959px) {
    width: 90vw;
  }
`;

const VideoLightbox = ({ src, cfStreamId, ...props }: {
  src: string;
  cfStreamId: string;
}) => {
  if (cfStreamId) {
    return (
      <CustomLightboxContainer {...props}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <IEFallbackWrapper
          forceMSIE
          fallback={(
            <ReactPlayer
              url={`https://videodelivery.net/${cfStreamId}/manifest/video.m3u8?clientBandwidthHint=1.8`}
              controls
              autoPlay
              config={{
                file: {
                  attributes: {
                    autoPlay: true,
                    disablePictureInPicture: true,
                    playsInline: true,
                    controlsList: 'nodownload noremoteplayback',
                  },
                },
              }}
              width="70vw"
              height="100%"
              style={{
                maxHeight: '80vh',
              }}
            />
          )}
        >
          <Stream
            autoplay
            controls
            src={cfStreamId}
            width="70vw"
          />
        </IEFallbackWrapper>
      </CustomLightboxContainer>
    );
  }

  return (
    <CustomLightboxContainer {...props}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <StyledVideo src={src} controls controlsList="nodownload noremoteplayback" autoPlay playsInline disablePictureInPicture />
    </CustomLightboxContainer>
  );
};

export default VideoLightbox;
